import { ErrorPage } from './ErrorPage';

export interface Error500PageProps {}

export const Error500Page = (props: Error500PageProps) => {
  return <ErrorPage contentCode="ERROR_500_CONTENT" />;
};
